<div class="mapa-content-container">
    <p-card *ngIf="paginacaoSuspensoes && paginacaoSuspensoes.totalItens > 0">
        <app-aviso-suspensao-intituicao [paginacaoSuspensoes]="paginacaoSuspensoes" [loadLazy]="loadLazySuspensoes"></app-aviso-suspensao-intituicao>
    </p-card>
    <div class="space-between"></div>
    <p-card *ngIf="paginacaoRevisoes && paginacaoRevisoes.totalItens > 0">
        <app-aviso-revisao-selo [paginacaoRevisoes]="paginacaoRevisoes" [loadLazy]="loadLazyRevisoes"></app-aviso-revisao-selo>
    </p-card>
</div>
